import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";
import { SURVEY_COLORS } from "../../shared/theme-constants";

// TODO: Review this post upgrading to tailwind to refactor,  to use tailwind classes instead of custom styles
interface IntroStepStylesProps {
  isMobile: boolean;
}

export const useIntroStepStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: (props: IntroStepStylesProps) => (props.isMobile ? "16px" : "24px"),
    maxHeight: (props: IntroStepStylesProps) => (props.isMobile ? "auto" : "calc(80vh - 88px)"),
    [theme.breakpoints.down("sm")]: {
      maxHeight: "none",
      overflowY: "visible",
    },
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: 600,
    marginBottom: "20px",
  },
  notesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginBottom: "16px",
  },
  highlightNote: {
    padding: "2px",
    display: "flex",
    flexDirection: "row",
    borderRadius: "6px",
    fontSize: "14px",
    lineHeight: 1.4,
    fontWeight: 600,
    backgroundColor: "#EAF4FF",
    color: "#103A66",
    borderLeft: "4px solid #2D6EA6",
    "& svg": {
      height: "16px",
      width: "16px",
      margin: "14px 5px 5px 10px",
    },
    marginBottom: "1em",
  },
  cardContainer: {
    display: "flex",
    gap: "12px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  selectionCard: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    margin: 0,
    backgroundColor: SURVEY_COLORS.BACKGROUND_WHITE,
    border: `2px solid ${SURVEY_COLORS.BORDER_DEFAULT}`,
    borderRadius: "12px",
    overflow: "hidden",
    cursor: "pointer",
    transition: "border-color 150ms ease, background-color 150ms ease",
    "&:hover": {
      borderColor: `${SURVEY_COLORS.BUTTON_PRIMARY}66`,
    },
    "&[data-selected='true']": {
      borderColor: SURVEY_COLORS.BUTTON_PRIMARY,
    },
    "&:focus-within:not([data-selected='true'])": {
      outline: `2px solid ${SURVEY_COLORS.BUTTON_PRIMARY}`,
      outlineOffset: "2px",
    },
    "& .MuiRadio-root": {
      padding: 0,
      margin: 0,
      color: SURVEY_COLORS.TEXT_PRIMARY,
      flexShrink: 0,
      "&.Mui-checked": {
        color: SURVEY_COLORS.BUTTON_PRIMARY,
      },
    },
  },
  cardHeader: {
    alignItems: "center",
    backgroundColor: theme.palette.grey[300],
    display: "flex",
    gap: "12px",
    padding: "12px 20px",
    width: "100%",
    boxSizing: "border-box",
    fontSize: "16px",
    fontWeight: 600,
    color: SURVEY_COLORS.TEXT_PRIMARY,
  },
  cardBody: {
    padding: "16px 20px",
    backgroundColor: SURVEY_COLORS.BACKGROUND_WHITE,
    "[data-selected='true'] &": {
      backgroundColor: SURVEY_COLORS.INFO_BACKGROUND,
    },
  },
  cardDescription: {
    color: SURVEY_COLORS.TEXT_PRIMARY,
    fontSize: "12px",
    lineHeight: "20px",
    whiteSpace: "pre-line",
    "& p": {
      margin: 0,
      fontSize: "14px",
      fontWeight: "bold",
      marginBottom: "12px",
    },
    "& ul": {
      margin: "0",
      paddingLeft: "8px",
      listStyle: "disc",
    },
    "& li": {
      margin: "4px 0 0  4px",
      lineHeight: 1.4,
    },
    "& li::marker": {
      color: SURVEY_COLORS.BUTTON_PRIMARY,
    },
  },
  actionButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "16px",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "stretch",
    },
  },
  primaryButton: {
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: 600,
    height: "40px",
    padding: "12px 16px",
    backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
    color: SURVEY_COLORS.MODAL_TEXT_WHITE,
    border: "none",
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    "& .MuiButton-endIcon": {
      marginLeft: "4px",
      "& svg": {
        fontSize: "12px !important",
      },
    },
    "&:hover": {
      backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
      fontWeight: 700,
      "& .MuiTouchRipple-child": {
        backgroundColor: "transparent",
      },
    },
    "&:disabled": {
      opacity: 0.5,
      backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
      color: SURVEY_COLORS.MODAL_TEXT_WHITE,
    },
  },
}));
